import React from 'react'
import request from 'superagent'

class NewsListPage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {news: [], isLoaded: false, selectedIndex: 0}
  }
  componentWillMount () {
    request
      .get('https://sharehouse-116bb.appspot.com/api/news')
      .end((err, res) => {
        if (err) {
          console.error(err)
        } else {
          console.log('Succeed to receive data.')
          this.setState({news: res.body.news, isLoaded: true})
        }
      })
  }
  clickHandler (e) {
    let newsList = document.getElementById('news-list')
    if (e.target.id === 'news-tab-dagashi') {
      newsList.style.backgroundColor = 'blue'
      this.setState({selectedIndex: 1})
    } else if (e.target.id === 'news-tab-event') {
      newsList.style.backgroundColor = 'darkgreen'
      this.setState({selectedIndex: 2})
    } else {
      newsList.style.backgroundColor = 'black'
      this.setState({selectedIndex: 0})
    }
  }
  render () {
    if (!this.state.isLoaded) return (<p className='news-loading'>読み込み中...</p>)
    let filteredNews = []
    let imageUrls = []
    let typeClass = ''
    let typeName = ''
    let rowNum = 0
    let snsLabel
    if (this.state.selectedIndex === 1) {
      filteredNews = this.state.news.filter(doc => doc.type === 'dagashi')
    } else if (this.state.selectedIndex === 2) {
      filteredNews = this.state.news.filter(doc => doc.type === 'event')
    } else {
      filteredNews = this.state.news
    }
    const news = filteredNews.map(doc => {
      imageUrls.push(doc.imageUrl)
      rowNum += 1
      if (doc.type === 'event') {
        typeName = 'イベント'
      }　else if (doc.type === 'dagashi') {
        typeName = '駄菓子屋'
      } else {
        typeName = 'お知らせ'
      }
      typeClass = 'news-type news-type-' + doc.type
      const date = new Date(doc.createDateTime['_seconds']*1000)
      const month = date.getMonth() + 1
      const formatted = date.getFullYear() + '年' + month + '月' + date.getDate() + '日'
      if (doc.sns === 'facebook') {
        snsLabel = <i className="fab fa-facebook"></i>
      }　else if (doc.sns === 'youtube') {
        snsLabel = <i className="fab fa-youtube"></i>
      }　else if (doc.sns === 'instagram') {
        snsLabel = <i className="fab fa-instagram"></i>
      }
      const imagePath = 'images/' + doc.imageName
      return (
        <a href={doc.linkUrl} key={rowNum}>
          <li className='news-list-item' key={doc.name}>
              <img className='news-image' src={imagePath} alt={doc.imageName}/>
              <div className="news-content">
                <span className={typeClass}>{typeName}</span>
                <span className='news-date'>{formatted}</span>
                <span className='news-title'>{snsLabel} {doc.title}</span>
              </div>
          </li>
        </a>
      )
    })
    return (
        <div className='news-info'>
          <h2>お知らせ一覧</h2>
          <ul className="breadcrumb">
            <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
              <a href="/" itemProp="url">
                <span itemProp="title"><i className="fas fa-home"></i> ホーム</span>
              </a>
            </li>
            <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
              <span itemProp="title"> <i className="fas fa-caret-right"></i> お知らせ一覧</span>
            </li>
          </ul>
          <ol className='news-list'>
            {news}
          </ol>
        </div>
    )
  }
}

export default NewsListPage


// WEBPACK FOOTER //
// ./src/NewsListPage.js